export const STATUS_OF_DEMOGRAPHIC_DATA = {
    p: {
        en: 'Provided',
        es: 'Proporcionado'
    },
    n: {
        en: 'None on file',
        es: 'Ninguno en el registro'
    },
    na: {
        en: 'N/A',
        es: 'N/A'
    }
} as Record<string, { en: string; es: string }>;
